import { render, staticRenderFns } from "./WebTwoCourseAction.vue?vue&type=template&id=12b8a47f&scoped=true&"
import script from "./WebTwoCourseAction.vue?vue&type=script&lang=js&"
export * from "./WebTwoCourseAction.vue?vue&type=script&lang=js&"
import style0 from "./WebTwoCourseAction.vue?vue&type=style&index=0&id=12b8a47f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b8a47f",
  null
  
)

export default component.exports